import { useState } from '#imports'
import type { RouteLocationNormalized } from 'vue-router'

export const CLICKED_PRODUCT_STATE_KEY = 'clickedProductCardData'

export type ReferrerRoute = {
  params: RouteLocationNormalized['params']
  hash: RouteLocationNormalized['hash']
  query: RouteLocationNormalized['query']
  path: RouteLocationNormalized['path']
  fullPath: RouteLocationNormalized['fullPath']
  routeName: RouteLocationNormalized['name']
  route: string
}

export type ClickedProductCardData = {
  listingId: string
  price: string
  referrerRoute: ReferrerRoute
  category?: string
}

export function getReferrerRoute(
  route: RouteLocationNormalized,
): ReferrerRoute {
  const matched = route.matched[route.matched.length - 1]

  return {
    params: route.params,
    hash: route.hash,
    query: route.query,
    path: route.path,
    fullPath: route.fullPath,
    routeName: route.name || '',
    route: matched?.path.replace(/\(.*?\)/g, '') ?? '',
  }
}

export function useProductClickStore() {
  const clickedProductCardData = useState<ClickedProductCardData | null>(
    CLICKED_PRODUCT_STATE_KEY,
    () => null,
  )

  return (data: ClickedProductCardData) => {
    clickedProductCardData.value = data
  }
}
